import { addFilter, removeFilter, FilterValues } from '@carto/react-redux'
import { FilterType } from '@carto/api-client'

import { getStore } from 'app/state/storeRegistry'
import { MapDatasetEnriched, WidgetType } from '../types'
import { getEnrichedDatasets } from '../state/keplerGlSlice'
import { sendMetricEvent } from 'features/metrics/model/metricsMutations'
import { MetricEventType } from 'features/metrics/api/metrics'

export function getCrossFilteringDataSourcesByColumn({
  column,
  widgetDataSourceId
}: {
  column?: string
  widgetDataSourceId: string
}): MapDatasetEnriched[] {
  const store = getStore()
  const dataSources = getEnrichedDatasets(store.getState())

  const widgetDataSource = dataSources.find((ds) => ds.id === widgetDataSourceId)
  const widgetColumn = column ? widgetDataSource?.metadata?.schema?.find((c) => c.name === column) : null

  if (!widgetColumn) return widgetDataSource ? [widgetDataSource] : []

  const crossFilteringDataSources = dataSources.filter((dataSource) => {
    const schema = dataSource.metadata?.schema
    const schemaColumn = schema?.find((c) => c.name === column)

    return schemaColumn?.type === widgetColumn?.type && schemaColumn?.name === widgetColumn?.name
  })

  return crossFilteringDataSources
}

export function changeFilters({
  dataSourceIds,
  column,
  widgetOwnerId,
  widgetType,
  filterType,
  values,
  params,
  ignore
}: {
  dataSourceIds: string[]
  column: string | undefined
  widgetOwnerId: string
  widgetType: WidgetType
  filterType: FilterType
  values: FilterValues
  params?: Record<string, unknown>
  ignore?: boolean
}) {
  const store = getStore()
  const mapId = store.getState().maps.currentMap?.id || 'unknown'

  if (!column) return

  if (values && values.length > 0) {
    dataSourceIds.forEach((dataSourceId) => {
      store.dispatch(
        addFilter({
          id: dataSourceId,
          column,
          // @ts-expect-error TODO(c4r): Migrating types.
          type: filterType,
          values,
          owner: widgetOwnerId,
          ...params,
          ...(ignore && { ignore })
        })
      )
    })
  } else {
    dataSourceIds.forEach((dataSourceId) => {
      store.dispatch(
        removeFilter({
          id: dataSourceId,
          column,
          owner: widgetOwnerId
        })
      )
    })
  }

  sendMetricEvent(MetricEventType.WidgetFilteringInteraction, {
    mapId,
    widgetId: widgetOwnerId,
    widgetType,
    crossFilteringType: dataSourceIds.length > 1 ? 'multiple' : 'single'
  })
}

export function removeCrossFiltersBySource(dataSourceId: string) {
  const store = getStore()

  const widgets = store.getState().builder.widgets
  const widgetsToRemoveFilters = widgets.filter(
    (w) => w.dataSource === dataSourceId && w.crossFilteringDataSourceIds?.length
  )

  widgetsToRemoveFilters.forEach((widget) => {
    widget.crossFilteringDataSourceIds?.forEach((id) => {
      store.dispatch(removeFilter({ id, column: widget.column }))
    })
  })
}

export function removeFiltersBySourceAndColumn(dataSourceIds: string[], column?: string) {
  if (!column) return

  const store = getStore()
  dataSourceIds.forEach((dataSourceId) => {
    store.dispatch(removeFilter({ id: dataSourceId, column }))
  })
}
